import intentHolder, {INTENT_FOR_EXISTING_CUSTOMER, INTENT_FOR_NEW_CUSTOMER} from "@/models/intent-holder";

let btClientInstance = undefined;
export function updateBTClientInstance(instance) {
    btClientInstance = instance;
}

export default function threeDSHandler(store, payment_method, options = {}) {
  const getters = store.getters;
  const state = store.state;
  let pm =getters.pm_list.filter((gw) => gw.enabled3ds==true && gw.type=="card")[0];
  const params = {
    amount: options.amount || getters.current_amount_due || (pm && pm.token_amount3ds) ,
    currencyCode: getters.currency_code || store.state.customer.data.preferred_currency_code,
    intent: getters.payment_intent
  }
  if (params["amount"] == undefined ) {
    params["amount"] = 100
  }

  return Promise.resolve().then(() => {
    if(state.auth.authenticated) {
      params["customerId"] = getters.customer_handle
      params["paymentSourceId"] = payment_method.reference_id
      params["gatewayId"] = payment_method.gateway_account_id
      return intentHolder.set(INTENT_FOR_EXISTING_CUSTOMER, params);
      }
    else {
      params["gatewayId"] = payment_method.gateway_account_id
      return intentHolder.set(INTENT_FOR_NEW_CUSTOMER, params);
    }
  }).then(({payment_intent}) => {
    store.dispatch("set_payment_intent", payment_intent)
    return payment_intent;
  }).then(payment_intent => {
      let threeDShandler = Chargebee.getInstance().create3DSHandler();
      let options = {};
      if(payment_intent.gateway == "braintree" && btClientInstance) {
          options["braintree"] = btClientInstance;
      }
      threeDShandler.setPaymentIntent(payment_intent, options);
      let params3ds = {}
      if(payment_method.tmp_token) {
          params3ds['tokenizer'] = () => Promise.resolve(payment_method.tmp_token);
      }
      else if(payment_method.number) {
        params3ds['card'] = {
          firstName:  payment_method.first_name,
          lastName: payment_method.last_name,
          number: payment_method.number.replace(/\s+/g, ''),
          cvv: payment_method.cvv,
          expiryMonth: payment_method.expiry_month,
          expiryYear: payment_method.expiry_year > 100 ? payment_method.expiry_year : (2000 + parseInt(payment_method.expiry_year))
        }
        let additionalInfo ={};
        // additionalInfo['email'] = payment_method.email; //Cbee payment method address doesn't have email, phone, company, address Line 3
        additionalInfo['billingAddress'] = {
          firstName:  payment_method.first_name,
          lastName: payment_method.last_name,
          addressLine1: payment_method.billing_addr1,
          addressLine2: payment_method.billing_addr2,
          city: payment_method.billing_city,
          state: payment_method.billing_state,
          stateCode: payment_method.billing_state_code,
          countryCode: payment_method.billing_country,
          zip: payment_method.billing_zip
        }
        additionalInfo['locale'] = getters.init_info_locale && getters.init_info_locale.slice(0,2);
        params3ds['additionalData'] = additionalInfo;
      }
      return threeDShandler.handleCardPayment(params3ds).then((intent) => {
        store.dispatch("set_payment_intent", intent);
        return intent;
      });
  })
}


// WEBPACK FOOTER //
// ./src/models/three-ds-handler.js